import { useContext } from 'react';
import { Typography, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { CircleLoader, PageContent } from 'components';
import Moment from 'react-moment';
import { usersContext } from '../../UsersContext';
import { applicationContext } from 'helpers/services';
import { CognitoStatus } from 'helpers/enums';
import DeleteUser from './DeleteUser';


let Results = () => {
    let { countries } = useContext(applicationContext);
    let { isLoading, isSearchDone, user } = useContext(usersContext);


    return (
        <PageContent>
            {isLoading && <CircleLoader />}
            {isLoading === false && isSearchDone === true && user !== undefined &&
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Email</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Country</TableCell>
                            <TableCell>Warranty</TableCell>
                            <TableCell>Cognito</TableCell>
                            {(user.foundInWarranty === true || user.cognitoStatus !== CognitoStatus.NotFound) &&
                                <TableCell />
                            }
                            {user.canDeleteUser === true && <TableCell />}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{user.name}</TableCell>
                            <TableCell>{user.countryCode && countries.getValueByKey(user.countryCode)}</TableCell>
                            <TableCell>
                                <Typography>
                                    {user.foundInWarranty ? 'User found' : 'User not found'}
                                </Typography>
                                {user.warrantyCreatedOn &&
                                    <Typography variant="caption">
                                        Registered on&nbsp;<Moment date={user.warrantyCreatedOn} format="LLL" />
                                    </Typography>
                                }
                            </TableCell>
                            <TableCell>
                                <Typography>
                                    {user.cognitoStatus === CognitoStatus.FoundAndConfirmed && 'User account found, confirmed'}
                                    {user.cognitoStatus === CognitoStatus.FoundAndUnconfirmed && 'User account found and unconfirmed'}
                                    {user.cognitoStatus === CognitoStatus.NotFound && 'User account not found'}
                                </Typography>
                                {user.cognitoCreatedOn &&
                                    <Typography variant="caption">
                                        Registered on&nbsp;<Moment date={user.cognitoCreatedOn} format="LLL" />
                                    </Typography>
                                }
                            </TableCell>
                            {(user.foundInWarranty === true || user.cognitoStatus !== CognitoStatus.NotFound) &&
                                <TableCell>
                                    {user.cognitoStatus === CognitoStatus.NotFound && user.foundInWarranty === false && 'User not found'}
                                    {user.cognitoStatus === CognitoStatus.NotFound && user.foundInWarranty === true && 'User must sign-up'}
                                    {user.cognitoStatus === CognitoStatus.FoundAndConfirmed && user.foundInWarranty === false && `User can login with ${user.providers}`}
                                    {user.cognitoStatus === CognitoStatus.FoundAndConfirmed && user.foundInWarranty === true && `User can login with ${user.providers}`}
                                    {user.cognitoStatus === CognitoStatus.FoundAndUnconfirmed && user.foundInWarranty === false && `User is unconfirmed and need to complete the sign-up process with ${user.providers} or account can be deleted`}
                                    {user.cognitoStatus === CognitoStatus.FoundAndUnconfirmed && user.foundInWarranty === true && `User is unconfirmed and need to complete the sign-up process with ${user.providers} or account can be deleted`}
                                </TableCell>
                            }
                            {user.canDeleteUser === true &&
                                <TableCell align="right">
                                    <DeleteUser />
                                </TableCell>
                            }
                        </TableRow>
                    </TableBody>
                </Table>
            }
        </PageContent>
    )
}

export default Results;